import { Button } from "@mui/material";
import { Card, message, Pagination } from "antd";
import { FaStar } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { Container } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../Config";
import { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import { dummyProducts } from "../dummyprduct";
import CardItem from "../CardItem";
import Categories from "../Home/Categories";

const AllCombos = () => {
  const isSmallDevice = useMediaQuery({ query: "(max-width: 767px)" });
  const [productData, setProductData] = useState<any>([]);
  const limit = isSmallDevice ? 2 : 3;
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageSize=12
      const [totalPages, setTotalPages] = useState<number>(1);
        const [totalResult, setTotalResult] = useState<number>(0);
      
        
      
    

  const navigate = useNavigate();
  const handleNavProductDetail = (slug: string) => {
    navigate(`/combo/${slug}`);
  };


  const handleIncrease = (index: number) => {
    const updated = [...productData];
    updated[index].quantiy += 1;
    setProductData(updated);
  };

  const handleDecrease = (index: number) => {
    const updated = [...productData];
    if (updated[index].quantiy > 1) {
      updated[index].quantiy -= 1;
      setProductData(updated);
    }
  };

  const getProducts = async (page:any) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/product?category=combos&isDeleted=false&page=${page}&limit=${pageSize}`
      );
      if (response.data.products.length > 0) {
        setProductData(response.data.products);
        setTotalPages(response.data.totalPages);
        setTotalResult(response.data.totalResults);
      }
      else{
        setProductData([]);
      }
    } catch (error: any) {
      console.log(error);
      setProductData([]);
    }
  };

  const handleAddToCart = (val: any, i: any) => {
    let cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const totalPrice = val.price * val.quantiy;
    const discountAmount = totalPrice * (val.discountInPercent / 100);

    const finalPrice = (totalPrice - discountAmount).toFixed(2);

    const orderData: any = {
      catrgory: "combos",
      orderId: Date.now(),
      lineItems: [
        {
          product: val._id,
          quantiy: val.quantiy,
          productPrice: val.price,
          discountInPercent: val.discountInPercent,
          discountedPrice:
            val.price - (val.price * val.discountInPercent) / 100,
        },
      ],
      type: "normal",
      deliverySlot: "",
      address: "",
      paymentMethod: "",
      paymentStatus: "",
      status: "",
      deliveryInstructions: "",
      isCancelled: false,
      cancellationReason: null,
      refundStatus: "",
      paymentAmount: parseFloat(finalPrice),
      productName: val.name,
      discountInPercent: val.discountInPercent,
      originalPrice: val.price,
      originalQuantity: val.minWeightInGrams,
      totalAmount: totalPrice,
    };

    cart.push(orderData);

    localStorage.setItem("cart", JSON.stringify(cart));

    message.success("Item added to cart!");
    window.dispatchEvent(new Event("storage"));
  };

  useEffect(() => {
    getProducts(currentPage);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentPage]);



  return (
    <>
      <Header />
      <section className="py-4">
        <Categories/>
        <Container>
          <p className="nav-all pb-1">
            <Link to="/">Home</Link> {">"} <span>Combos</span>
          </p>
          <div className="allitems-nav">
          <h1>
              Combos <span>{totalResult} Varieties</span>
            </h1>
            </div>

          <div className="row">
            {productData.length > 0 &&
              productData
                .map((product: any, index: any) => (
                  <div className="col-lg-3 col-xxl-3 col-xl-3 col-sm-6 col-6 col-md-4 mt-2 ">
                  <CardItem key={product._id} product={product} />
                  </div>
                  // <div
                  //   key={index}
                  //   className="col-lg-4 col-xxl-4 col-xl-4 item-card col-sm-6 col-6 col-md-4 mt-2 allitems"
                  // >
                  //   <div className="position-relative mobile-card">
                  //     <Card
                  //       style={{
                  //         width: "100%",
                  //         overflow: "hidden",
                  //         borderBottomRightRadius: isSmallDevice
                  //           ? "10px"
                  //           : "10px",
                  //         cursor: "pointer",
                  //       }}
                  //       cover={
                  //         <img
                  //           alt="img"
                  //           className="item-img"
                  //           loading="lazy"
                  //           src={`${API_URL}/images/${val?.image}`}
                  //         />
                  //       }
                  //       onClick={() => handleNavProductDetail(val?.slug)}
                  //     />
                  //     <div className="d-flex justify-content-between align-items-center item-head">
                  //       <div>
                  //         <div className="ratingStar m-2">
                  //           <span
                  //             className="d-flex justify-content-center align-items-center"
                  //             style={{
                  //               fontSize: "15px",
                  //               fontWeight: 600,
                  //               color: "#000",
                  //             }}
                  //           >
                  //             <FaStar
                  //               style={{ marginRight: "5px", color: "#D11243" }}
                  //             />
                  //             {val?.rating || 1}
                  //           </span>
                  //         </div>
                  //       </div>
                  //     </div>
                  //     <div
                  //       className="item-foot p-2"
                  //       style={{ borderBottomRightRadius: "10px" }}
                  //     >
                  //       <div
                  //         className="d-flex flex-wrap justify-content-between pb-2 card-dec1"
                  //         style={{ width: "100%" }}
                  //       >
                  //         <div
                  //           className="mb-0"
                  //           style={{
                  //             width: `${isSmallDevice ? "auto" : "60%"}`,
                  //           }}
                  //         >
                  //           <h6 className="card-item-head two-line-ellipsis position-relative">
                  //             {val?.name || "-"}
                  //           </h6>
                  //         </div>
                  //         <div
                  //           className="increDec"
                  //           style={{
                  //             width: `${isSmallDevice ? "auto" : "25%"}`,
                  //           }}
                  //         >
                  //           <span
                  //             className="minus"
                  //             onClick={() => handleDecrease(index)}
                  //           >
                  //             -
                  //           </span>
                  //           <span className="inputQuantity">
                  //             {val?.quantiy}
                  //           </span>
                  //           <span
                  //             className="plus"
                  //             onClick={() => handleIncrease(index)}
                  //           >
                  //             +
                  //           </span>
                  //         </div>
                  //       </div>
                  //       <div
                  //         className="d-flex justify-content-between flex-wrap align-items-center card-dec1"
                  //         style={{ width: "100%" }}
                  //       >
                  //         <div>
                  //           <h4 className="card-price">₹{val?.price}/-</h4>
                  //         </div>

                  //         <div>
                  //           <Button
                  //             variant="contained"
                  //             className="cartBtn"
                  //             onClick={() => handleAddToCart(val, index)}
                  //           >
                  //             Add To Cart
                  //           </Button>
                  //         </div>
                  //       </div>
                  //     </div>
                  //   </div>
                  // </div>
                ))}
          </div>
           <div className="d-flex justify-content-center mt-4">
                      <Pagination
                        current={currentPage}
                        total={totalPages * pageSize}
                        pageSize={pageSize}
                        onChange={(page) => setCurrentPage(page)}
                      />
                    </div>
        
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default AllCombos;
